<ui-modal-single [heading]="heading()">
  <ng-template #contentSlot>
      <div class="children-horizontal-gap-4 m-max-height">

          <div>
            <ui-streamline-icon class="me-1 m-lock-icon-color"
                  [slIcon]="{name: 'lock-1', theme: 'bold',size:'sm'}">
            </ui-streamline-icon>
            <span class="fw-semibold f-caption m-lock-icon-color me-1">Private</span>
            <span class="f-caption text-neutral-700">Only managers can see perform notes, they will not be visible to staff.</span>
          </div>

          <div>
            <label class="m-label" for="manager">Who is this perform note about?*</label>
            @if(editedLog()) {
              <staff-link-display [rowData]="editedLog().staffOrgUser"></staff-link-display>
            } @else {
              <app-selector-single-user label="" [control]="logForm.controls.staffOrgUserID"
                [submitted]="submitAttempted()" [activeUserOnly]="true">
              </app-selector-single-user>
              <!-- <app-selector-multi-user label="" [control]="logForm.controls.staffOrgUserID" [submitted]="submitAttempted()"></app-selector-multi-user> -->
            }
            <div *ngIf="showErrorMsg('staffOrgUserID')">
              <span class="f-caption text-danger pt-2">User is required</span>
            </div>
          </div>

          <div>
            <label class="m-label" for="occur-date">When did this occur?*</label>
            <app-ngb-date-selector name="occurDate" id="occur-date" [futureDates]="false" [control]="logForm.get('occurDate')">
            </app-ngb-date-selector>
            <div *ngIf="showErrorMsg('occurDate')">
              <span class="f-caption text-danger pt-2">Occur date is required</span>
            </div>
          </div>

          <div>
            <label class="m-label" for="note">Note*</label>
            <ckeditor class="f-small" id="note" [formControl]="logForm.get('note')" [config]="EDITOR_CONFIG">
            </ckeditor>
            <!-- <textarea class="form-control f-small" name="note" id="note" [formControl]="logForm.get('note')" [rows]="4">
            </textarea> -->
            <div *ngIf="showErrorMsg('note')">
              <span class="f-caption text-danger pt-2">Note is required</span>
            </div>
          </div>

          <mat-divider></mat-divider>

          <div>
            <label class="m-label" for="evidence">Attach Evidence</label>
            @for(evidence of evidences; track $index;){
              <app-perform-log-evidence-card [evidence]="evidences[$index]" (deleteEvidenceChange)="deleteEvidence($index)"></app-perform-log-evidence-card>
            }
            <button class="btn btn-outline-light" id="evidence" (click)="addEvidence()" type="button">+ Add Evidence</button>
          </div>

          <div>
            <label class="m-label" for="type">Type</label>
            <ng-select id="type" [formControl]="logForm.get('type')" [items]="typeItems"
              bindLabel="label" bindValue="value" [closeOnSelect]="true" [searchable]="false"
              class="m-custom-select"
              [clearable]="false">
            </ng-select>
          </div>

          <div>
            <label for="action" class="m-label">Action</label>
            <ng-select id="action" [formControl]="logForm.get('action')" [items]="actionItems"
              bindLabel="label" bindValue="value" [closeOnSelect]="true" [searchable]="false"
              class="m-custom-select"
              [clearable]="false">
            </ng-select>
          </div>

          <!-- <div class="form-group text-neutral-900 fw-medium my-3" *featureFlag="FEATURES.compliance"> -->
            <div>
                <div class="w-100 mb-2">
                    <p class="text-neutral-900 fw-medium f-small col-4 mb-2">Related Regulatory Standards</p>
                    <div class="w-100">
                        <app-customised-multi-select-for-guidelines
                          [items]="guidelines()" name="guideline"
                          bindLabel="name" bindValue="guidelineID"
                          [control]="logForm.get('guidelines')" [groupByValue]="'provider'"
                          valueMode="formControl">
                        </app-customised-multi-select-for-guidelines>
                    </div>
                </div>

                <div class="w-100 mb-2">
                    <div class="w-100">
                      <app-org-standards-selector [control]="logForm.get('orgStandards')" [headerClass]="'fw-medium f-small'">
                      </app-org-standards-selector>
                    </div>
                </div>

                <div class="w-100 mt-2">
                  <p class="text-neutral-900 fw-medium f-small col-4 mb-2">Capability Frameworks</p>
                  <div class="w-100">
                      <app-customised-multi-select-for-org-capabilities [items]="enabledOrgCapabilities()"
                          name="capabilities" bindLabel="name" bindValue="standardID"
                          [control]="logForm.get('orgCapabilities')" [groupByValue]="'frameworkName'"
                          valueMode="formControl">
                      </app-customised-multi-select-for-org-capabilities>
                  </div>
              </div>
            </div>
          <!-- </div> -->

          <div>
            <p class="fw-semibold">Tags</p>
            <p class="text-neutral-700">These tags are not visible to the user receiving feedback</p>
          </div>

          <div>
            <label class="mb-1" class="m-label" for="sentiment">What is the sentiment of this feedback?</label>
            <div>
                  <ui-toggle-buttons [items]="sentimentOptions" [model]="logForm.controls.sentiment.value"
                      (modelChange)="logForm.controls.sentiment.setValue($event)"
                      [hasFullWidth]="true"></ui-toggle-buttons>
              </div>
          </div>

      </div>
  </ng-template>

  <ng-template #rightSlot>
      <button class="btn btn-outline-light me-2" (click)="dismiss()">Close</button>
      <!-- <button (click)="submit()" class="btn btn-secondary">Add Feedback</button> -->
      <app-processing-button
          [ngbTooltip]="''"
          tooltipClass="custom-tooltip" container="body" (click)="submit()"
          [text]="editedLog() ? 'Update' : 'Add'" [isLoading]="isSubmitting()"
          [disabled]="isSubmitting() || logForm.invalid">
      </app-processing-button>
  </ng-template>
</ui-modal-single>
